<template>
  <GuideViewPC v-if="isMobile === 'PC'" />
  <GuideViewH5 v-if="isMobile === 'MOBILE'" />
</template>

<script setup>
import GuideViewPC from './components/GuideViewPC/index.vue'
import GuideViewH5 from './components/GuideViewH5/index.vue'
import { useUserStore } from '@/pinia/user'
import { useLoginModal } from '@/components/Login'

const isMobile = ref(false)
onBeforeMount(async () => {
  const userAgent = navigator.userAgent.toLowerCase()
  isMobile.value = /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent) ? 'MOBILE' : 'PC'
})

const user = useUserStore()
const router = useRouter()
const route = useRoute()
const { open: openLoginModal } = useLoginModal()

watch(() => user.isLogged, (logged) => {
  if (logged) {
    /**
     * 需移除 email, password 这些登录信息
     */
    const { fallback, email, password, ...query } = route.query
    router.replace({
      path: fallback,
      params: route.params,
      query
    })
  }
})

onMounted(() => {
  openLoginModal()
})
</script>
